import { render, staticRenderFns } from "./Registries.vue?vue&type=template&id=7f5235eb&"
import script from "./Registries.vue?vue&type=script&lang=js&"
export * from "./Registries.vue?vue&type=script&lang=js&"
import style0 from "./Registries.vue?vue&type=style&index=0&id=7f5235eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports